import React from 'react';
import CRMdasboard from '../../../crm/myworkspace/Dashboard/CRMdasboard';
import CertificateGenerator from './CertificateGenerator';

export default function CROdashboard() {
  return <CRMdasboard CRO={true} CertificateGenerator={CertificateGenerator} />;
}
